import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import UserImg1 from "./images/users/1.jpg";
import UserImg2 from "./images/users/2.jpg";
import UserImg3 from "./images/users/3.jpg";
import "./css/reviews.css";
import { useLanguage } from '../context/LanguageContext';


const Reviews = () => {
    const { t, currentLanguage } = useLanguage();
    const swiperRef = useRef(null);

    const reviews = [
    {
        id: 1,
        name: t('reviews.testimonials.0.name'),
        role: t('reviews.testimonials.0.role'),
        text: t('reviews.testimonials.0.text'),
        stars: 4,
        img: UserImg1,
    },
    {
        id: 2,
        name: t('reviews.testimonials.1.name'),
        role: t('reviews.testimonials.1.role'),
        text: t('reviews.testimonials.1.text'),
        stars: 5,
        img: UserImg2,
    },
    {
        id: 3,
        name: t('reviews.testimonials.2.name'),
        role: t('reviews.testimonials.2.role'),
        text: t('reviews.testimonials.2.text'),
        stars: 4,
        img: UserImg3,
    },
    {
        id: 4,
        name: t('reviews.testimonials.3.name'),
        role: t('reviews.testimonials.3.role'),
        text: t('reviews.testimonials.3.text'),
        stars: 5,
        img: UserImg1,
    },
    {
        id: 5,
        name: t('reviews.testimonials.4.name'),
        role: t('reviews.testimonials.4.role'),
        text: t('reviews.testimonials.4.text'),
        stars: 5,
        img: UserImg2,
    },
    ];

    // Reinitialize Swiper when language changes
    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.update();
            swiperRef.current.swiper.slideTo(0);
        }
    }, [currentLanguage]);

    return (
    <section className="reviews">
    <div className="container">
        <div className="section-header">
        <h1>{t('reviews.title')}</h1>
        </div>

        <Swiper
        ref={swiperRef}
        key={currentLanguage} // Force re-render when language changes
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        centeredSlides={true}
        loop={true}
        grabCursor={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 3 },
        }}
        onSlideChange={(swiper) => {
            // Add custom active classes
            const slides = swiper.slides;
            slides.forEach((slide) => slide.classList.remove("first-active", "second-active", "third-active"));

            const activeIndex = swiper.activeIndex;
            slides[activeIndex]?.classList.add("first-active");
            slides[activeIndex + 1]?.classList.add("second-active");
            slides[activeIndex + 2]?.classList.add("third-active");
        }}
        aria-label="Client testimonials carousel"
        >
        {reviews.map((review) => (
            <SwiperSlide key={review.id}>
            <div className="review">
                <div className="text">
                <div className="stars">
                    {Array.from({ length: 5 }, (_, i) => (
                    <i
                        key={i}
                        className={`las la-star ${i >= review.stars ? "shaded" : ""}`}
                    ></i>
                    ))}
                </div>
                <p>{review.text}</p>
                </div>
                <div className="client-info">
                <img src={review.img} alt={review.name} />
                <div>
                    <h4>{review.name}</h4>
                    <h5>{review.role}</h5>
                </div>
                </div>
            </div>
            </SwiperSlide>
        ))}
        </Swiper>
    </div>
    </section>
);
};

export default Reviews;
